import './horsLigne/index.js';
import { QueryClientProvider } from '@tanstack/react-query';
import { ToastProvider } from '@artosera/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import '@artosera/ui/tokens.css';
import '@artosera/ui/regie-design-tokens.css';
import '@artosera/ui/fonts.css';
import '@artosera/ui/reset.css';
import '@artosera/ui/base.css';
import './appearance/themes.css';
import './appearance/shellAppearance.css';
import './appearance/atelier.css';
import './appearance/collection.css';
import './appearance/structure.css';
import './appearance/blanc.css';
import './appearance/spatial.css';
import './appearance/chrome.css';
import './appearance/brut.css';
import './appearance/aurore.css';
import './appearance/monolithe.css';
import './appearance/liquid-glass.css';
import './appearance/verre-de-jour.css';
import './appearance/verre-de-nuit.css';
import './appearance/liste-oeuvres.css';
import './appearance/halo.css';
import { initializeDesign } from './appearance/designStore.js';
import { DesignIdentitySync } from './appearance/DesignIdentitySync.js';
import { demarrerLiquidGlass } from './appearance/liquid-glass-refraction.js';
import { activerModeDemonstrationDepuisUrl } from './api/demo.js';
import { queryClient } from './auth/queryClient.js';
import { creerRouteur } from './router.js';
import { themeSombreSiFoireAuDemarrage } from './routes/shell/useAutoFairLayout.js';
import './i18n.js';

// Doit précéder `creerRouteur()` : la fabrique déclenche aussitôt le
// chargeur de la route initiale, qui lit le drapeau posé ici.
activerModeDemonstrationDepuisUrl(import.meta.env.BASE_URL === '/templates/demo/');
// Avant le montage : évite que `ThemeToggle` affiche un instant l'icône
// « clair » sur une tablette en dessous de 1024 px (2.6, D5).
themeSombreSiFoireAuDemarrage();
initializeDesign();
demarrerLiquidGlass();
const router = creerRouteur();

const racine = document.getElementById('racine');

if (!racine) {
  throw new Error('Élément racine introuvable.');
}

createRoot(racine).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <DesignIdentitySync />
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
